// extracted by mini-css-extract-plugin
export default {"root":"NoPermissionModal_root__YC0Mf","body":"NoPermissionModal_body__yA4e3"};